import { SimpleChanges } from "@angular/core";
import { Subject } from "rxjs";
import { DynamicGrid } from "../dynamic.model";
import { ListColumn } from "../metadata.model";
import { RowTools } from "../row-tools.model";

export class BaseListComponent {
  public subs: any = {};
  public lookups: any = {};
  public isLoading: boolean = false;
  public model: DynamicGrid<any>;
  public refreshSubject: Subject<{}> = new Subject<{}>();
  public params: any = {};

  public rowCount = 0;
  public first = 0;
  public rows = 50;
  public sortField = null;
  public sortOrder = 0;
  public query = null;

  public userRoleId = null;

  protected childKey = '';

  public showModal: boolean = false;
  public isAdding: boolean = false;
  public isEditing: boolean = false;
  public isDeleting: boolean = false;

  public selection: any = null;

  public class: string = null;
  public title: string = null;

  public rowTools: RowTools = new RowTools();
  public hover: string = null;

  public isAdmin: boolean = false;

  constructor() {
    this.isAdmin = !!localStorage.getItem('isAdmin');

    if (this.isAdmin == null)
      this.isAdmin = false;
  }

  public anyChange(key: string, changes: SimpleChanges): boolean {
    if (changes == null || key == null || changes[key] == null)
      return false;

    return changes[key].isFirstChange() || (changes[key].currentValue != changes[key].previousValue);
  }

  public toast(success: boolean, message: string) {
    return {
      severity: success ? 'success' : 'error',
      summary: null,
      detail: message,
      closable: false,
      life: 10000
    }
  }

  public resetGridState() {
    this.first = 0;
    this.rows = 50;
    this.sortField = null;
    this.sortOrder = 0;
  }

  public setGridState(e: any) {
    this.first = e.first;
    this.rows = e.rows;
    if (e.sortField != undefined) {
      this.sortField = e.sortField;
    }
    if (e.sortOrder != undefined) {
      this.sortOrder = e.sortOrder;
    }
    this.query = this.query ? this.query : e.globalFilter;
  }

  public safeUnsub(key: string) {
    if (this.subs != null) {
      if (this.subs[key] != null) {
        this.subs[key].unsubscribe();
      }
    }
  }

  public loadColumns(columns: ListColumn[]) {
    this.model.clearCols();

    columns.forEach(c => {
      let visible = true;
      if (c.adminOnly === true && this.isAdmin === false) {
        visible = false;
      }

      if (c.type === 'hidden') {
        this.model.addHidden(c.key);
      } else {
        let d = this.model.addCol(c.type, c.key, c.label, c.width, c.lookupKey);
        d.visible = visible;
      }
    })
  }

  get visibleColumns() {
    if (this.model == null || this.model.columns == null || this.model.columns.length == 0)
      return [];
    return this.model.columns.filter(c => c.visible === true).sort((a, b) => { return (a.order > b.order ? 1 : -1) });
  }

  get filterableColumnKeys(): string[] {
    if (this.model == null || this.model.columns == null || this.model.columns.length == 0)
      return [];
    return this.model.columns.filter(c => c.filterable === true).map(c => c.key);
  }

  get anyFilterableColumns(): boolean {
    return this.filterableColumnKeys.length > 0;
  }

  get numColumns(): number {
    return  this.visibleColumns.length + 1;
  }

  setRowColour(event: any) {
    // Find index of a row and set colour
    if (event.id) {
      const rowIndex = this.model.rows.findIndex((m) => {
        return m.id === event.id;
      });
      if (rowIndex > -1) {
        if (event.colourCodeStatusOIP) {
          this.model.rows[rowIndex].oipColourCode = event.oipColourCode;
        } else {
          this.model.rows[rowIndex].colourCode = event.colourCode;
        }
      }
    }
   }
}
